<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-09-25 16:44:00
 * @Description: 合同——明细客商弹窗界面（分tab版本）
 * @FilePath: \PCMS\src\views\ShareSystem\components\contract\detailSupply.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false"  :before-close="reset" @open="open">
            <span slot="title" class="dialog-title">明细客户</span>
            <div class="dialoginfo">
                <div style="margin-bottom: 20px;">
                    <div  style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
                        <div >
                            <span style="margin-right: 15px;">编码:</span>
                            <el-input v-model="tableParams.code" style="width: 180px;margin-right: 15px;"  placeholder="请输入编码"></el-input>
                            <span style="margin-right: 15px;">名称:</span>
                            <el-input v-model="tableParams.name" style="width: 180px" placeholder="请输入名称"></el-input>
                        </div>
                        <el-button size="small" class="bottom_all" @click="initData">搜索</el-button>
                        <el-button size="small" class="bottom_one" @click="restParams">重置</el-button>
                    </div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div id="tabs" class="tabs" >
                          <div class="tabs-header">
                            <div v-for="item in tabList" :key="item.id" class="tabs-nav-item" :class="{isActive:tableParams.currenIndex==item.id}" @click="changeTab(item.id)">{{item.label}}</div>
                          </div>
                          <div v-loading="loading" class="tabs-content" >
                            <transition name="fade" mode="out-in">
                              <div :key="tableParams.currenIndex">
                                <component
                                  :is="comName"
                                  ref="componentRef"
                                  :tableDatasss="tableData"
                                  :secondNameCount="secondNameCount"
                                  :tableLoadings="tableLoading"
                                  :tableHeights="500"
                                  @setRow="setRow"
                                  @dbClickRow="dbClickRow"
                                  @getList="initData()"
                                ></component>
                              </div>
                            </transition>
                          </div>
                        </div>
                        <!-- <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark"  highlight-current-row @current-change="handleCurrentChange">
                          <template v-for="(item, index) in table">
                            <el-table-column :prop="item.prop" :label="item.label" :width="item.width" align="center" v-if="item" :key="index" show-overflow-tooltip>
                              <template slot-scope="scope">
                                <span v-if="item.label == '序号'">
                                  {{ scope.$index + 1 }}
                                </span>
                                <span v-else>{{ scope.row[item.prop] }}</span>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table> -->
                </div>
                <div class="card_bottom" style="height:100%">
                    <div class="card_bottom_left">
                        <div class="top_page_totle">总共{{ total }}条</div>
                        <el-pagination :page-size="tableParams.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" :current-page.sync="tableParams.page" @size-change="sizeChange" @current-change="initData()"></el-pagination>
                    </div>
                    <div>
                        <el-button size="mini" class="bottom_all_two" @click="initData()">刷新</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
                <el-button class="bottom_all" @click="submitProfit">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { cardLogin_HX,queryProfitDetail,getSupplier_HX} from "@/views/ShareSystem/api/mainHx.js";
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
import profitTable from "@/views/ShareSystem/components/contract/tablePage/profitTable";
import customerTable from "@/views/ShareSystem/components/contract/tablePage/customerTable";
export default {
    components: {
        profitTable,
        customerTable,
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        saveType: {
            type: String,
            default: "",
        },
        isCustomer: {
            type: Boolean,
            default: false,
        },
        detailRow:{}
    },
    data(){
        return {
            tableParams:{
                page:1,
                pageSize:10,
                code:"",
                name:"",
                status:1,//只查询启用状态
                currenIndex:1
            },
            accessToken:"",
            total:0,
            tableData:[],
            secondNameCount:[],
            table:[
              { label: "序号", width: "80", prop: "id", status: true },
              { label: "客商编码", width: "auto", prop: "code", status: true },
              { label: "客商名称", width: "auto", prop: "name", status: true },
            //   { label: "税号", width: "auto", prop: "profitCenterAttributeName", status: true },
            ],
            currentRow:{},
            tabList:[
            {id: 1, label: '利润中心'},
            {id: 2, label: '客商信息'},
          ],
          comNameList: {
              1:'profitTable',
              2:'customerTable',
          },
          comName: 'profitTable',
          tableLoading: false,
            form:{},
            loading:false,
        }
    },
    watch:{
        
    },
    methods:{
      open(){
        this.changeTab(1)
      },
        changeTab(tab) {
          this.comName = this.comNameList[tab];
          this.tableParams.currenIndex = tab;
          this.tableParams.page = 1;
          this.initData();
      },
        async initData(){
          let that = this
         
          let res = await cardLogin_HX({ idCard: "icps" })
            if (res.code == 1001) {
              let info = res.data;
              if (info && info.accessToken) {
                that.accessToken = info.accessToken
                if(this.detailRow){
                  // if(this.isCustomer){
                  //   this.tableParams.name = this.detailRow.profitCenterName
                  // }else{
                  //   this.tableParams.name = this.detailRow.profitCsName
                  // }
                }
                if(this.tableParams.currenIndex == 1){
                    this.queryProfitDetail(that.accessToken);
                }else{
                    this.getCustomerDetail(that.accessToken);
                }
              }
            }
            
        },
        restParams(){
           this.tableParams={
                page:1,
                pageSize:10,
                code:"",
                name:"",
                currenIndex:1,
            }
            this.initData();
        },
        queryProfitDetail(accessToken){
          this.loading = true
            queryProfitDetail(this.tableParams,accessToken).then(res => {
                if(res.code == 1001) {
                    this.tableData = res.data.data
                    this.total = res.data.totalRows
                    this.loading = false
                }
            })
        },
        getCustomerDetail(accessToken) {
            if(!accessToken){
              this.$message.error('accessToken获取为空～')
              return;
            }
            this.loading = true
            getSupplier_HX(this.tableParams, accessToken).then((res) => {
                if(res.code == 1001) {
                    this.tableData = res.data.data
                    this.total = res.data.totalRows
                    this.loading = false
                }
            });
        },
        handleCurrentChange(val){
            this.currentRow = val;
        },
        reset() {
          this.restParams();
          this.$emit("reset");
        },
        setRow(value){
            this.currentRow = value
        },
        dbClickRow(value){
          console.log(value)
          this.currentRow = value
          this.submitProfit()
        },
        setIdRow(){},
        submitProfit(){
          console.log(this.currentRow)
          console.log(this.detailRow)
            if(Object.keys(this.currentRow).length === 0){
                this.$message.warning("请先选择一个客商！！！");
                return
            }else{
              if(this.saveType == 1){
                // let params = {}
                // if(this.isCustomer){
                //   params = {
                //       id: this.detailRow.id,
                //       profitCenterName:this.currentRow.name,
                //       profitCenterCode:this.currentRow.code,
                //   }
                // }else{
                //   params = {
                //     id: this.detailRow.id,
                //     profitCsName:this.currentRow.name,
                //     profitCsCode:this.currentRow.code,
                //   }
                // }
                // alterContractProfitCenter( params).then(res => {
                //     if (res.code == 1001) {
                //         this.$message({ type: "success", message: res.codeMsg });
                //         this.$emit('reset')
                //     }
                // })
              }else{
                let params = {}
                if(this.isCustomer){
                  params = {
                      profitCenterName:this.currentRow.name,
                      profitCenterCode:this.currentRow.code,
                  }
                }else{
                  params = {
                    profitCsName:this.currentRow.name,
                    profitCsCode:this.currentRow.code,
                  }
                }
                // let params = {
                //     profitCsName:this.currentRow.name,
                //     profitCsCode:this.currentRow.code,
                // }
                this.$emit("setDetail",params)
              }
            }
            this.reset();
        },
        sizeChange(value) {
            this.tableParams.pageSize = value;
            this.initData();
        },
    }
}
</script>
<style lang="scss" scoped>
.tabs-nav-item{
  width: 100px;
}
.addClass{
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}
.mr15{
  margin-right: 15px;
}
::v-deep .el-table__body tr.current-row > td {
    color: #fff;
    background: #00b85c !important;
}
</style>